var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouncilCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66602 13.6837C1.66602 8.78108 1.66602 6.32979 3.18906 4.80673C4.71211 3.28369 7.1634 3.28369 12.066 3.28369H17.266C22.1686 3.28369 24.62 3.28369 26.1429 4.80673C27.666 6.32979 27.666 8.78108 27.666 13.6837V16.2837C27.666 21.1863 27.666 23.6377 26.1429 25.1606C24.62 26.6837 22.1686 26.6837 17.266 26.6837H12.066C7.1634 26.6837 4.71211 26.6837 3.18906 25.1606C1.66602 23.6377 1.66602 21.1863 1.66602 16.2837V13.6837Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4656 18.8837H19.8656M19.8656 18.8837H17.2656M19.8656 18.8837V16.2837M19.8656 18.8837V21.4837",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.16602 3.2835V1.3335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.166 3.2835V1.3335",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.31641 9.78369H27.0164",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouncilCalendarIcon);
export default __webpack_public_path__ + "static/media/council-calendar-icon.973c0d72bde9b520c9446fe4d457c572.svg";
export { ForwardRef as ReactComponent };